<template>
    <div class="deals-items">
        <DealsItem v-for="deal in deals"
                   :key="deal.leadNumber"
                   :deal-data="deal" />
    </div>
</template>

<script>
import DealsItem from '@/blocks/DealsBlock/DealsItems/DealsItem';

export default {
    name: 'DealsItems',

    components: {
        DealsItem
    },

    props: {
        deals: Array
    },
};
</script>

<style lang="scss">
@import "DealsItems";
</style>
